<template>
  <div class="borrow-page">
    <div class="header">
      <img src="@/assets/images/borrow-bg.png" class="header-bg" />
      <div class="header-content">
        <span class="max-loan">{{decryptLabel('nQsSnPJsHGRkKJDDGL/1TkMwZgbWxQRlgkzUzNjfArg=')}}</span>
        <span class="amount">200000</span>
      </div>
    </div>
    
    <div class="features">
      <div class="feature-row">
        <div class="feature-item">
          <img src="@/assets/images/document.png" class="feature-icon" />
          <span class="feature-title">200000</span>
          <span class="feature-desc">{{decryptLabel('7w7kggewtqek3oxSdRIR0g==')}}</span>
        </div>
        <div class="feature-item">
          <img src="@/assets/images/rate.png" class="feature-icon" />
          <span class="feature-title">0.25%</span>
          <span class="feature-desc">{{decryptLabel('lrKW7xjgVvh9ug0wnWYzWA==')}}</span>
        </div>
      </div>
      
      <div class="feature-row">
        <div class="feature-item">
          <img src="@/assets/images/clock.png" class="feature-icon" />
          <span class="feature-title">最长可至24个月</span>
          <span class="feature-desc">{{decryptLabel('22qqU6xuP07Yy5+5KiTFog==')}}</span>
        </div>
        <div class="feature-item">
          <img src="@/assets/images/wallet.png" class="feature-icon" />
          <span class="feature-title">支付宝/微信/{{decryptLabel('LnFDWPHcPmqq1QPhoKPwww==')}}</span>
          <span class="feature-desc">{{decryptLabel('pgT8AEINcseJgUXPk8PT7A==')}}</span>
        </div>
      </div>
    </div>
    
    <button class="borrow-btn" @click="submitjk">{{decryptLabel('/YKsbc2mJgYc8fEE65gC7Q==')}}</button>
  </div>
</template>

<script>
import { decryptData } from '@/utils/security'

export default {
  data() {
    return {}
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    submitjk() {
      this.$warning('积分不足')
    }
  }
}
</script>

<style scoped>
.borrow-page {
  padding: 0;
  min-height: 100vh;
  padding-bottom: calc(72px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #f0fdf4 0%, #f8fafc 100%);
}

.header {
  position: relative;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0 0 32px 32px;
  box-shadow: 0 8px 32px rgba(15, 181, 76, 0.18);
}

.header-content {
  position: relative;
  z-index: 2;
  text-align: left;
  margin-left: -40%;
}

.max-loan {
  display: block;
  font-size: 15px;
  color: #fff;
  margin-bottom: 8px;
  font-weight: 500;
  letter-spacing: 0.5px;
  opacity: 0.95;
}

.amount {
  display: block;
  font-size: 36px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 1px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.features {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 32px 32px 0 0;
  margin-top: -20px;
  padding: 36px 16px 8px;
  box-shadow: 0 -6px 24px rgba(15, 181, 76, 0.06);
}

.feature-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}

.feature-item {
  width: 47%;
  background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 18px;
  padding: 22px 14px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.9);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.feature-item:active {
  transform: scale(0.96);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.feature-icon {
  width: 46px;
  height: 46px;
  margin-bottom: 12px;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.12));
}

.feature-title {
  display: block;
  font-size: 17px;
  font-weight: 800;
  color: #0FB54C;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

.feature-desc {
  display: block;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  letter-spacing: 0.2px;
}

.borrow-btn {
  width: 88%;
  margin: 12px auto 24px;
  display: block;
  background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
  color: #fff;
  border-radius: 28px;
  height: 56px;
  line-height: 56px;
  font-size: 18px;
  font-weight: 800;
  border: none;
  box-shadow: 0 6px 20px rgba(15, 181, 76, 0.45);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 1px;
}

.borrow-btn:active {
  transform: translateY(2px) scale(0.98);
  box-shadow: 0 3px 12px rgba(15, 181, 76, 0.5);
}
</style>
